module.exports = __webpack_public_path__ + "img/ycbx-ac.95922de7.png";